import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { PatientHistoryEntry } from 'src/app/data/patient-history-entry';
import { SimplifiedStudy, Study } from 'src/app/data/study';
import { PatientHistoryService } from 'src/app/services/patient-history.service';
import { StudiesService } from 'src/app/services/studies.service';
import { Tab } from '../bottom-nav/tab.type';

@Component({
  selector: 'app-mobile-history',
  templateUrl: './mobile-history.component.html',
  styleUrls: ['./mobile-history.component.css']
})
export class MobileHistoryComponent implements OnInit {

  @Input() actualBookStudies: Study[] = [];

  @Output('onClickChangeTab') onClickChangeTabEmitter = new EventEmitter<Tab>();
  @Output() openVisor = new EventEmitter();
  @Output() openVisorFromHistoricStudy = new EventEmitter<{ studyUID: string, studyToken: string }>();
  @Output() openBookFromHistoricStudy = new EventEmitter<{ studyUID: string, studyToken: string }>();

  loading = false;
  error = false;

  //actualBookStudies: Study[] = [];
  historicStudiesList: SimplifiedStudy[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private studiesService: StudiesService,
    private historyService: PatientHistoryService,
  ) {}

  ngOnInit(): void {
    if (this.actualBookStudies == null) {
      setTimeout(() => {
        this.ngOnInit();
      }, 100);
      return;
    }

    this.loadHistory();
  }

  loadHistory() {
    if (!this.actualBookStudies) return;
    this.loading = true;
    this.error = false;
    
    if (this.actualBookStudies.length > 0 && this.actualBookStudies[0].studyUID) {

      this.getHistoricStudies(this.actualBookStudies[0].studyUID).then(historicStudies => {
        this.historicStudiesList = historicStudies.filter(s => this.actualBookStudies.findIndex(st => st.studyUID == s.studyUID) == -1);
        this.historicStudiesList.sort((a, b) => b.studyDate!.getTime() - a.studyDate!.getTime());
        this.loading = false;
      }).catch(error => {
          console.error(error);
          this.loading = false;
          this.error = true;
      });
    }
  }
      

  getHistoricStudies(studyMasterUID: string): Promise<SimplifiedStudy[]> {
  
    return new Promise((resolve, reject) => {
      if(studyMasterUID != null && studyMasterUID != ""){
        this.studiesService.getOtherPatientStudies(studyMasterUID).then(historicStudies => {
          resolve(historicStudies);
        })
      }else{
        reject('No study master UID provided');
      }
    })
  }

  formatDate(date: Date | null): string {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  changeTab(tab: Tab){
    this.onClickChangeTabEmitter.emit(tab);
  }

  openAdvancedVisor(studyUID: string){
    this.openVisor.emit();
  }

  openAdvancedVisorFromHistoric(studyUID: string, studyToken: string){
    this.openVisorFromHistoricStudy.emit({ studyUID, studyToken });
  }

  openBookFromHistoric(studyUID: string, studyToken: string){
    this.openBookFromHistoricStudy.emit({ studyUID, studyToken });
  }


  
  
}
